import { Component, inject, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tournament-policy',
  templateUrl: './tournament-policy.component.html',
  styleUrls: ['./tournament-policy.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, EmptyPageModule, TranslateModule],
})
export class TournamentPolicyComponent  implements OnInit {
  modalController = inject(ModalController);
  @Input() tournament: any;
  organisation: any
  constructor() { }

  ngOnInit() {
    this.organisation = this.tournament?.organisation;
  }

  async modalDissmissed() {
    await this.modalController.dismiss();
  }
}
